<template>
  <div class="offer-sales-common-container" :class="bgAndBorder">
    <div v-if="limitedOffers.length === 0 && !previewMode" class="no-offers">
      <span>Nenhum produto foi encontrado com a sua busca.</span>
    </div>

    <div v-for="(offer, index) in limitedOffers" :key="index" :class="getOfferClasses(offer)">
      <div class="offer-sale-content">
        <div v-if="isProductsGroupPreview && isMobile" class="blue-chip mb-2" :class="getInactiveOfferSaleClass(offer)">Grupo de produtos</div>
        <div class="img-container">
          <img v-if="imageExists(offer)" :src="imageSource(offer)" alt="imagem do produto" width="100%" :class="getInactiveOfferSaleClass(offer)" />
          <mf-icon v-else size="36" :class="getInactiveOfferSaleClass(offer)">image_not_supported</mf-icon>
        </div>
        <div class="right-container">
          <div v-if="isProductsGroupPreview && !isMobile" class="blue-chip mb-2" :class="getInactiveOfferSaleClass(offer)">Grupo de produtos</div>
          <span class="product-name" :class="getInactiveOfferSaleClass(offer)">{{ getOfferProductName(offer) | truncate({ length: 80 }) }}</span>

          <voucher-digital-mechanic
            v-if="!isInsideProductsGroup && isMobile"
            class="left-container"
            :class="getInactiveOfferSaleClass(offer)"
            :offer="offer"
            :preview-mode="previewMode"
          />
          <div class="sku-ean-container" :class="getInactiveOfferSaleClass(offer)">
            <span v-if="!isInsideProductsGroup" class="format-rebate-text">
              <strong>Voucher (pago pela indústria): </strong>
              <span>{{ calcPromotionText(offer) }}</span>
            </span>

            <span v-if="isProductsGroupPreview" class="cinza-0-14px"><strong>Produtos: </strong>{{ getProductsLength(offer) }}</span>
            <span v-else class="cinza-0-14px"><strong>SKU: </strong>{{ getOfferSku(offer) }}</span>

            <product-ean
              v-if="!isProductsGroupPreview"
              :offer="offer"
              :disabled="!offer.active || previewMode"
              :preview-mode="previewMode"
              is-voucher-digital
              :is-inside-products-group="isInsideProductsGroup"
            />
            <div class="d-flex flex-row align-center" style="gap: 16px">
              <span v-if="showMechanicText && offer.trigger_rules.trigger_amount" class="cinza-0-14px">
                <strong>Mín. CPF: </strong>{{ offer.trigger_rules.trigger_amount }}
              </span>
              <span v-if="showMechanicText" class="cinza-0-14px"><strong>Máx. CPF: </strong>{{ offer.trigger_rules.maximum_per_client }}</span>
            </div>
          </div>

          <div v-if="!previewMode" class="status-container" :class="getToggleBackground(offer)">
            <mf-toggle v-model="offer.active" :label="offer.active ? 'Produto ativo na campanha' : 'Produto inativo na campanha'" hide-details />
          </div>
        </div>
      </div>
      <voucher-digital-mechanic
        v-if="!isInsideProductsGroup && !isMobile"
        class="left-container"
        :class="getInactiveOfferSaleClass(offer)"
        :offer="offer"
        :preview-mode="previewMode"
      />
    </div>
    <div v-if="previewMode" class="see-more" @click="$emit('goToDetails')">
      <mf-icon v-if="remainingOffersLength > 0" color="marca-0-l10" size="18">add</mf-icon>
      <span>{{ getSeeMoreMessage }}</span>
    </div>
  </div>
</template>

<script>
import VoucherDigitalMechanic from '../products-mechanics/VoucherDigitalMechanic.vue'
import { localeString } from '@/config/helpers.js'
import ProductEan from '../field-edit/ProductEan.vue'

export default {
  name: 'OfferSalesDigitalVoucher',
  components: {
    VoucherDigitalMechanic,
    ProductEan,
  },
  props: {
    offerSales: {
      type: Array,
      required: true,
    },
    isProductsGroupPreview: {
      type: Boolean,
      default: false,
    },
    isInsideProductsGroup: {
      type: Boolean,
      default: false,
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showOffersLimit() {
      return this.previewMode ? (this.isMobile ? 1 : 3) : this.offerSales.length
    },
    limitedOffers() {
      return this.offerSales.length > this.showOffersLimit ? this.offerSales.slice(0, this.showOffersLimit) : this.offerSales
    },

    remainingOffersLength() {
      let remainingOffersLength = 0
      if (!this.isProductsGroupPreview) {
        remainingOffersLength = this.offerSales.length - this.showOffersLimit
      }
      return remainingOffersLength
    },

    getSeeMoreMessage() {
      if (this.remainingOffersLength > 0) {
        return `Ver mais ${this.remainingOffersLength} produto${this.remainingOffersLength > 1 ? 's' : ''}`
      } else return 'Ver mais detalhes'
    },

    bgAndBorder() {
      return this.previewMode ? 'bg-cinza-l90 preview-mode-border' : 'bg-white'
    },

    showMechanicText() {
      return this.isMobile && !this.isProductsGroupPreview && !this.isInsideProductsGroup
    },
  },
  methods: {
    calcPromotionText(offer) {
      return `R$ ${localeString(offer?.benefits?.value, 2)}`
    },

    imageExists(offer) {
      if (this.isInsideProductsGroup) {
        return offer?.image_url && offer?.image_url?.length > 0
      }
      return offer?.trigger_products[0]?.image_url && offer?.trigger_products[0]?.image_url?.length > 0
    },

    imageSource(offer) {
      if (this.isInsideProductsGroup) {
        return offer?.image_url
      }
      return offer?.trigger_products[0]?.image_url
    },

    getOfferProductName(offer) {
      if (this.isInsideProductsGroup) {
        return offer?.name
      } else if (this.isProductsGroupPreview) {
        return offer?.trigger_products[0]?.group_name
      }
      return offer?.trigger_products[0]?.name
    },

    getOfferSku(offer) {
      if (this.isInsideProductsGroup) {
        return offer?.sku
      }
      return offer?.trigger_products[0]?.sku
    },

    getInactiveOfferSaleClass(offer) {
      return !offer.active && !this.previewMode ? 'inactive-campaign' : ''
    },

    getOfferClasses(offer) {
      return [
        'offer-sale-item',
        {
          'normal-item-padding': !this.previewMode,
          'preview-mode-item-padding': this.previewMode,
          'outside-group-padding': !this.isInsideProductsGroup,
          'inactive-background': !offer.active && !this.previewMode,
        },
      ]
    },

    getToggleBackground(offer) {
      return offer.active ? 'bg-cinza-l90' : 'bg-white'
    },

    getProductsLength(offer) {
      if (this.isInsideProductsGroup) {
        return offer?.length
      }
      return offer?.trigger_products?.length
    },
  },
}
</script>

<style lang="scss" scoped>
.offer-sales-common-container {
  border-radius: 8px;
  border-top-width: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.preview-mode-border {
  border: 1px solid $cinza-l70;
}

.bg-cinza-l90 {
  background: $cinza-l90;
}

.inactive-background {
  background-color: #f5f6f7;
}

.bg-white {
  background: white;
}

.product-name,
.sku-ean-container,
.blue-chip,
.left-container {
  transition: opacity 0.5s ease;
}

.inactive-campaign {
  opacity: 0.5;
}

.no-offers {
  display: flex;
  justify-content: center;
  padding: 52px;
  padding-bottom: 36px;
}

.offer-sale-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  transition: background-color 0.5s ease;
  border-bottom: 1px solid $cinza-l70;

  @media screen and (max-width: $xs-breakpoint) {
    border-width: 2px;
    justify-content: center;
  }
}

.normal-item-padding {
  padding: 20px 88px;

  @media screen and (max-width: $xs-breakpoint) {
    padding: 32px 16px;
  }
}

.preview-mode-item-padding {
  padding: 20px 56px 20px 76px;

  @media screen and (max-width: $xs-breakpoint) {
    padding: 32px 16px;
  }
}

.outside-group-padding {
  padding: 28px 40px 20px 40px;

  @media screen and (max-width: $xs-breakpoint) {
    padding: 32px 16px !important;
  }
}

.offer-sale-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;

  @media screen and (max-width: $xs-breakpoint) {
    flex-direction: column;
  }

  .blue-chip {
    padding: 4px 16px;
    border-radius: 16px;
    font-size: 14px;
    font-weight: bold;
    background: #d2e9ff80;
    color: $marca-0-l10;
    white-space: nowrap;
    width: fit-content;
    user-select: none;
  }

  .product-name {
    font-size: 1rem;
    font-weight: bold;
    color: $cinza-d10;

    @media screen and (max-width: $xs-breakpoint) {
      text-align: center;
    }
  }

  .format-rebate-text {
    font-size: 14px;
    color: $verde-d20;
    order: 0;

    @media screen and (max-width: $xs-breakpoint) {
      order: 4;
    }
  }

  .cinza-0-14px {
    font-size: 14px;
    color: $cinza-0;
  }

  .right-container {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .sku-ean-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      gap: 20px;

      @media screen and (max-width: $xs-breakpoint) {
        gap: 12px;
      }
    }

    .status-container {
      width: 542px;
      padding: 8px 12px;
      border-radius: 8px;
      transition: background-color 0.5s ease;

      @media screen and (max-width: $xs-breakpoint) {
        width: 100%;
      }
    }
  }
}

.img-container {
  width: 74px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;

  & * {
    transition: opacity 0.5s ease;
  }

  & img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    mix-blend-mode: darken;
    object-fit: contain;
  }
}

.see-more {
  background: #d2e9ff99;
  color: $marca-0-l10;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    cursor: pointer;
    background-color: #b4dbff99;
  }
}
</style>
